import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRef } from 'vue'
import YagiChatBotInputArea from '@/components/format-edit/yagi-chat-bot/YagiChatBotInputArea.vue'
import YagiChatBotMessages from '@/components/format-edit/yagi-chat-bot/YagiChatBotMessages.vue'
import { useYagiChatBot } from '@/composables/format-edit/useYagiChatBot'
import type {
  YagiChatFormValue,
  YagiChatQuestion
} from '@/utils/format-edit/yagiChatBot'


export default /*#__PURE__*/_defineComponent({
  __name: 'YagiChatBot',
  props: {
    modalName: null,
    questions: null,
    value: null,
    autoSkipFilled: { type: Boolean, default: true },
    showUsageCount: { type: Boolean, default: false },
    usageCount: { default: null },
    maxUsageCount: { default: 1 },
    usageCountLabel: { default: '利用回数' },
    chatType: { default: 'unknown' },
    completeButtonText: { default: 'AI文章作成をする' },
    headerTitle: { default: 'ヤギコンシェルジュ' },
    headerSubtitle: { default: 'ヤギッシュ公式チャットボットです' },
    welcomeMessage: { default: '' }
  },
  emits: ["input", "complete", "close"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'input', value: YagiChatFormValue): void
  (e: 'complete', value?: YagiChatFormValue): void
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modalName: string, questions: YagiChatQuestion[], value: YagiChatFormValue, autoSkipFilled: boolean, showUsageCount: boolean, usageCount: number | null, maxUsageCount: number, usageCountLabel: string, chatType: string, completeButtonText: string, headerTitle: string, headerSubtitle: string, welcomeMessage: string };

/**
 * ヤギチャットボット（vue-final-modal）。
 * 開閉・公開 API は defineExpose（親の $refs.open 等を維持）。
 */




const messagesRef = ref<{ rootEl: HTMLElement | null } | null>(null)

const {
  visible,
  currentQuestionIndex,
  chatMessages,
  currentAnswer,
  isComposing,
  showResult,
  result,
  isLoadingCompanyInfo,
  allQuestionsCompleted,
  aiResultMode,
  thinkingMode,
  thinkingLabel,
  currentQuestion,
  chatDate,
  open,
  closeDialog,
  onVisibleInput,
  showResultView,
  showThinkingIndicator,
  hideThinkingIndicator,
  showAiResultConfirm,
  handleAiResultAccept,
  handleAiResultRegenerate,
  handleAiResultEdit,
  resumeFromQuestionId,
  markCompleted,
  pushChatMessage,
  handleEnterKey,
  submitAnswer,
  submitNoneAnswer,
  submitQuickReply,
  editSkippedQuestions,
  handleQuestionsComplete,
  skipUrlQuestion,
  submitUrlAnswer,
  editCompanyInfo
} = useYagiChatBot({
  modalName: toRef(props, 'modalName'),
  questions: toRef(props, 'questions'),
  value: toRef(props, 'value'),
  autoSkipFilled: toRef(props, 'autoSkipFilled'),
  chatType: toRef(props, 'chatType'),
  welcomeMessage: toRef(props, 'welcomeMessage'),
  emitInput: (v) => emit('input', v),
  emitComplete: (v) => emit('complete', v),
  emitClose: () => emit('close'),
  getChatMessagesEl: () => {
    const exposed = messagesRef.value
    if (!exposed) return null
    const el = exposed.rootEl
    // Vue 2.7 expose では Ref のまま渡ることがある
    if (el && typeof el === 'object' && 'value' in el) {
      return (el as { value: HTMLElement | null }).value
    }
    return el ?? null
  }
})

const questions = computed(() => props.questions)

expose({
  open,
  closeDialog,
  showResultView,
  showThinkingIndicator,
  hideThinkingIndicator,
  showAiResultConfirm,
  resumeFromQuestionId,
  markCompleted,
  pushChatMessage,
  chatMessages
})

return { __sfc: true,props, emit, messagesRef, visible, currentQuestionIndex, chatMessages, currentAnswer, isComposing, showResult, result, isLoadingCompanyInfo, allQuestionsCompleted, aiResultMode, thinkingMode, thinkingLabel, currentQuestion, chatDate, open, closeDialog, onVisibleInput, showResultView, showThinkingIndicator, hideThinkingIndicator, showAiResultConfirm, handleAiResultAccept, handleAiResultRegenerate, handleAiResultEdit, resumeFromQuestionId, markCompleted, pushChatMessage, handleEnterKey, submitAnswer, submitNoneAnswer, submitQuickReply, editSkippedQuestions, handleQuestionsComplete, skipUrlQuestion, submitUrlAnswer, editCompanyInfo, questions, YagiChatBotInputArea, YagiChatBotMessages }
}

})